// src/components/ProductCard2.js
import React from 'react';
import './ProductCard2.css'; // Nouveau fichier CSS pour ce style de carte

function ProductCard2({ imageSrc, name, description, subInfo, price }) {
  return (
    <div className="product-card-v2"> {/* Classe racine différente */}
      <div className="product-card-v2-image-container">
        <img src={imageSrc} alt={name} className="product-card-v2-image" loading="lazy" />
      </div>
      <div className="product-card-v2-content">
        <h3 className="product-card-v2-name">{name}</h3>
        {subInfo && <p className="product-card-v2-subinfo">{subInfo}</p>}
        <p className="product-card-v2-description">{description}</p>
        {price && <p className="product-card-v2-price">{price}</p>}
      </div>
    </div>
  );
}

export default ProductCard2;